import versePolygonStakingData from './verseStakingPolygonData';

const farmsSepoliaList = [versePolygonStakingData];

export default farmsSepoliaList;
